import { Routes } from '@angular/router';
import { PLACE_PARENT_SLUGS, PLACE_STORE_CHILDREN, type PlaceParentSlug } from './places.constants';

const loadHotelStorefront = () =>
  import('../hotel-business-dashboard/public-profile-hotel-store.component').then(
    (m) => m.PublicProfileHotelStoreComponent
  );

function childrenForPlace(place: PlaceParentSlug): Routes {
  return (PLACE_STORE_CHILDREN[place] ?? []).map((child) => {
    if (child.kind === 'hotel') {
      return {
        path: child.path,
        loadComponent: loadHotelStorefront,
        data: { slug: child.path, storeCode: child.path, place }
      };
    }
    return { path: child.path, redirectTo: '/' };
  });
}

/** Parent city routes: `/gangtok/...`, `/vizag/...`, … */
export const placesParentRoutes: Routes = PLACE_PARENT_SLUGS.map((place) => ({
  path: place,
  children: childrenForPlace(place)
}));
